module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-7-9a61a8694ecfd1730f89cfdd3034ef0f.webp";